// React & Libraries
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';

// Ant Design
import { Drawer, Table, DatePicker, notification, Select, Popconfirm } from 'antd';
import { EditFilled, CloseOutlined, PlusCircleFilled } from '@ant-design/icons';

// UI Lib Components
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';

// Actions
import DCActions from '@Actions/dcActions.js';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ProductActions from '@Actions/productActions';
import DocConfigActions from '@Actions/docConfigActions';
import CurrenciesActions from '@Actions/configurations/currenciesAction';
import CustomStatusActions from '../../../../actions/configurations/customStatusActions';

// Constants & Helpers
import { QUANTITY, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';

// Form Components
import AddressSelector from '@Components/Common/FormUtils/AddressSelecter';
import CustomFieldV3 from '@Components/Common/CustomFieldV3';
import SelectTax from '@Components/Admin/Common/SelectTax';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import SelectCustomer from '@Components/Common/SelectCustomer';
import SelectSeller from '@Components/Common/SelectSeller';
import SelectDepartment from '@Components/Common/SelectDepartment';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import DocumentNumberSeqInput from '../../../Admin/Common/DocumentNumberSeqInput';

// Common Components
import ProductCategoryLabel from '../../../Common/ProductCategoryLabel';
import RichTextEditor from '../../../Common/RichTextEditor';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import CustomDocumentColumns from '@Components/Common/CustomDocumentColumns';

// PRZ UI Components
import PRZSelect from '../../../Common/UI/PRZSelect';
import PRZButton from '../../../Common/UI/PRZButton';

// Assets & Styles
import Crown from '@Images/crown2.png';
import '../../../Sales/Invoice/InvoiceForm/InvoiceLines/style.scss';
import './style.scss';

const { Option } = Select;

class DeliveryChallanForm extends Component {
  constructor(props) {
    super(props);
    const { selectedInvoice, selectedSt } = props;
    this.state = {
      transportName: '',
      vehicleNumber: '',
      shippingWeight: '',
      driverPhone: '',
      ebill: '',
      shippingAddress: '',
      billingAddress: '',
      dcDate: dayjs(),
      deliveryDate: dayjs(),
      selectedCurrencyName: '',
      selectedCurrencyID: '',
      currencyConversionRate: '',
      visibleColumns: {
        PRODUCT: {
          label: 'Product',
          visible: true,
          disabled: false,
        },
        TRANSFER_QUANTITY: {
          label: 'Transfer Quantity',
          visible: !!selectedSt,
          disabled: true,
        },
        INVOICE_QUANTITY: {
          label: 'Invoice Quantity',
          visible: !!selectedInvoice,
          disabled: true,
        },
        QUANTITY: {
          label: 'Quantity',
          visible: true,
          disabled: false,
        },
        RATE: {
          label: 'Rate',
          visible: true,
          disabled: false,
        },
        TAX: {
          label: 'Tax',
          visible: true,
          disabled: false,
        },
        DISCOUNT: {
          label: 'Discount %',
          visible: true,
          disabled: false,
        },
        TOTAL: {
          label: 'Total',
          visible: true,
          disabled: true,
        },
      },
      deliveryChallanLines: [
        {
          key: uuidv4(), asset1: '', product_sku_name: '', quantity: '', tax_id: null, uom_id: null, lineCustomFields: [],
        },
      ],
      isShowDriverDetails: false,
      challanFor: 'CUSTOMER',
      selectedCustomer: '',
      currentTenantDepartment: Helpers.getTenantDepartmentId(props?.user),
      currentTenant: props?.user?.tenant_info?.tenant_id,
      t_and_c: '',
      gstNumber: ''
    };
  }

  componentDidMount() {
    const {
      getDocCFV2, user, selectedInvoice, edit, selectedSt, getCurrencies, getDocConfig, getCustomStatus,
    } = this.props;
    getCurrencies();
    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'DELIVERY_CHALLAN',
    };
    getDocCFV2(payload);
    getDocConfig(user?.tenant_info?.tenant_id, 'DELIVERY_CHALLAN');
    if (selectedSt && edit) {
      const tenantDepartmentId = selectedSt.source_tenant_department_id;
      const deliveryChallanLines = selectedSt?.delivery_challan_lines;
      const data = deliveryChallanLines?.map((i) => ({
        ...i,
        key: uuidv4(),
        dc_quantity: i.dc_qty,
        quantity: i.st_qty,
        remarks: i.remarks,
        discount: i?.line_discount_percentage,
        showFreebie: i?.free_quantity > 0,
        dc_free_quantity: i?.free_quantity,
        tax_info: i?.tax_group_info,
      }));
      this.setState({
        transportName: selectedSt?.transporter_name,
        vehicleName: selectedSt?.vehicle_type,
        vehicleNumber: selectedSt?.vehicle_number,
        shippingWeight: selectedSt?.shipment_weight,
        driverName: selectedSt?.driver_name,
        driverPhone: selectedSt?.driver_phone,
        ebill: selectedSt?.e_way_bill_number,
        isShowDriverDetails: !!selectedSt?.transporter_name,
        fileList: selectedSt?.e_way_bill_attachment,
        deliveryChallanLines: data,
        tenantDepartmentId,
        gstNumber: selectedSt?.gst_number,
        dcNumber: selectedSt?.dc_number || '',
      });
    } else if (selectedInvoice && edit) {
      const tenantDepartmentId = selectedInvoice.source_tenant_department_id;
      const deliveryChallanLines = selectedInvoice?.delivery_challan_lines;
      const data = deliveryChallanLines?.map((i) => ({
        ...i,
        invoice_gen_quantity: 0,
        dc_quantity: i.dc_qty,
        quantity: i.i_qty,
        key: uuidv4(),
        discount: i?.line_discount_percentage,
        showFreebie: i?.free_quantity > 0,
        dc_free_quantity: i?.free_quantity,
        tax_info: i?.tax_group_info,
        product_category_info: i?.product_category_info || i?.product_sku_info?.product_category_info,
      }));
      this.setState({
        dcNumber: selectedInvoice?.dc_number,
        transportName: selectedInvoice?.transporter_name,
        vehicleName: selectedInvoice?.vehicle_type,
        vehicleNumber: selectedInvoice?.vehicle_number,
        driverName: selectedInvoice?.driver_name,
        shippingWeight: selectedInvoice?.shipment_weight,
        ebill: selectedInvoice?.e_way_bill_number,
        fileList: selectedInvoice?.e_way_bill_attachment,
        isShowDriverDetails: !!selectedInvoice?.transporter_name,
        deliveryChallanLines: data,
        tenantDepartmentId,
        selectedCustomer: selectedInvoice?.dc_customer_id,
        t_and_c: selectedInvoice?.t_and_c || '',
        gstNumber: selectedInvoice?.gst_number,
        accountManager: selectedInvoice?.account_manager_id,
      });
    }
    const payloadForCustomStatus = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'DELIVERY_CHALLAN',
    };
    getCustomStatus(payloadForCustomStatus);
  }

  static getDerivedStateFromProps(props, state) {
    const {
      user, CurrenciesResults, edit,
    } = props;

    if (CurrenciesResults && CurrenciesResults?.length > 0) {
      const defaultCurrency = CurrenciesResults?.find((currency) => currency.is_default === true);
      if (defaultCurrency && !state.selectedCurrencyID) {
        return {
          ...state,
          selectedCurrencyID: defaultCurrency?.org_currency_id,
          selectedCurrencyName: defaultCurrency,
          currencyConversionRate: user?.tenant_info?.global_config?.settings?.automatic_conversion_rate ? defaultCurrency?.automatic_conversion_rate : defaultCurrency?.conversion_rate,
        };
      }
    }

    if (props.cfV2DocDeliveryChallan?.data?.success && !state.isUserReadyOne) {
      let oldCustomField = [];
      if (props.selectedSt) {
        oldCustomField = props?.selectedSt?.custom_fields || [];
      } else if (props.selectedInvoice) {
        oldCustomField = props?.selectedInvoice?.custom_fields || [];
      } else {
        oldCustomField = [];
      }
      return {
        ...state,
        cfDeliveryChallanDoc: oldCustomField?.length ? CustomFieldHelpers.mergeCustomFields(props.cfV2DocDeliveryChallan?.data?.document_custom_fields, oldCustomField) : CustomFieldHelpers.getCfStructure(props.cfV2DocDeliveryChallan?.data?.document_custom_fields, []),
        isUserReadyOne: true,
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(props.cfV2DocDeliveryChallan?.data?.document_line_custom_fields, state?.visibleColumns),
        cfDeliveryChallanLine: CustomFieldHelpers.getCfStructure(props.cfV2DocDeliveryChallan?.data?.document_line_custom_fields, []),
      };
    }
    if (props?.selectedSt && !state.isUserReady && props?.cfV2DocDeliveryChallan?.data?.success) {
      const tenantDepartmentId = props?.selectedSt.source_tenant_department_id;
      const deliveryChallanLines = props?.selectedSt?.stock_transfer_lines?.map((i) => ({
        ...i,
        key: uuidv4(),
        quantity: i.quantity,
        dc_quantity: i.quantity,
        hsn_code: i?.hsn_code || i?.product_sku_info?.hsn_code,
        tax_id: i?.product_sku_info?.tax_info?.tax_id || i?.tax_group_info?.tax_id,
        tax_info: i?.product_sku_info?.tax_info,
        unit_price: i?.product_sku_info?.cost_price || 0,
        showFreebie: i?.free_quantity > 0,
        dc_free_quantity: i?.free_quantity,
        product_category_info: i?.product_category_info || i?.product_sku_info?.product_category_info,
        discount: i?.line_discount_percentage,
        lineCustomFields: CustomFieldHelpers.mergeCustomFields(props.cfV2DocDeliveryChallan?.data?.document_line_custom_fields, i?.custom_fields)?.map((cf) => ({
          ...cf,
          fieldValue: cf?.fieldName === 'Quantity' ? Number(i?.quantity) : cf?.fieldValue,
        })) || [],
        custom_fields: props.cfV2DocDeliveryChallan?.data?.document_line_custom_fields,
      }));
      return {
        ...state,
        isUserReady: true,
        shippingAddress: props?.selectedSt?.destination_department_info?.tenant_billing_address_info || props?.selectedSt?.destination_address,
        shippingAddressId: props?.selectedSt?.destination_department_info?.tenant_billing_address_info?.address_id || props?.selectedSt?.destination_address?.address_id,
        billingAddressId: props?.selectedSt?.source_department_info?.tenant_billing_address_info?.address_id || props?.selectedSt?.source_address?.address_id,
        billingAddress: props?.selectedSt?.source_department_info?.tenant_billing_address_info || props?.selectedSt?.source_address,
        fileList: props?.selectedSt?.e_way_bill_attachment,
        deliveryChallanLines,
        tenantDepartmentId,
        currentTenantDepartment: props?.selectedSt?.source_tenant_department_id,
        currentTenant: props?.selectedSt?.source_department_info?.tenant_id,
        t_and_c: props?.selectedSt?.t_and_c || '',
        gstNumber: edit ? props?.selectedSt?.gst_number : props?.selectedSt?.destination_department_info?.gst_number,
        selectedDestination: props?.selectedSt?.destination_tenant_id || props?.selectedSt?.destination_tenant_department_info?.tenant_id || props?.selectedSt?.tenant_id,
        challanFor: 'INTERNAL_STOCK_TRANSFER',
      };
    }
    if (props?.selectedInvoice && !state.isUserReady && props?.docConfigDeliveryChallan && props?.cfV2DocDeliveryChallan?.data?.success) {
      const tenantDepartmentId = props?.selectedInvoice.source_tenant_department_id;
      let deliveryChallanLines = '';
      let lines = [];

      if (props?.selectedInvoice?.invoice_lines?.length > 0) {
        lines = props.selectedInvoice.invoice_lines;
      } else if (props?.selectedInvoice?.sales_order_lines?.length > 0) {
        lines = props.selectedInvoice.sales_order_lines;
      } else if (props?.selectedInvoice?.delivery_challan_lines?.length > 0) {
        lines = props.selectedInvoice.delivery_challan_lines;
      }

      if (lines.length > 0) {
        deliveryChallanLines = lines.map((i) => ({
          ...i,
          invoice_gen_quantity: 0,
          dc_quantity: Number(i.quantity),
          key: uuidv4(),
          hsn_code: i?.hsn_code || i?.product_sku_info?.hsn_code,
          discount: i?.line_discount_percentage,
          free_quantity: Number(i?.free_quantity),
          showFreebie: i?.free_quantity > 0,
          dc_free_quantity: i?.free_quantity,
          tax_info: i?.tax_group_info,
          unit_price: i?.unit_price * props?.selectedInvoice?.conversion_rate,
          product_category_info: i?.product_category_info || i?.product_sku_info?.product_category_info,
          lineCustomFields: CustomFieldHelpers.mergeCustomFields(props.cfV2DocDeliveryChallan?.data?.document_line_custom_fields, i?.custom_fields)?.map((cf) => ({
            ...cf,
            fieldValue: cf?.fieldName === 'Quantity' ? Number(i?.quantity) : cf?.fieldValue,
          })) || [],
          custom_fields: props.cfV2DocDeliveryChallan?.data?.document_line_custom_fields,
        }));
      }
      return {
        ...state,
        isUserReady: true,
        shippingAddress: props?.selectedInvoice?.shipping_address_info || props?.selectedInvoice?.destination_address,
        shippingAddressId: props?.selectedInvoice?.shipping_address_info?.address_id || props?.selectedInvoice?.destination_address?.address_id,
        billingAddressId: props?.selectedInvoice?.ship_from_address_info?.address_id || props?.selectedInvoice?.source_address?.address_id || props?.selectedInvoice?.tenant_shipping_address_info?.address_id,
        billingAddress: props?.selectedInvoice?.ship_from_address_info || props?.selectedInvoice?.source_address || props?.selectedInvoice?.tenant_shipping_address_info,
        fileList: props?.selectedInvoice?.e_way_bill_attachment,
        deliveryChallanLines,
        tenantDepartmentId,
        currentTenantDepartment: props?.selectedInvoice?.tenant_department_id,
        selectedCustomer: props?.selectedInvoice?.customer_id,
        currentTenant: props?.selectedInvoice?.tenant_id,
        t_and_c: (props?.documentType === 'Invoice' ? props.docConfigDeliveryChallan?.data?.find((item) => item?.document_type === 'DELIVERY_CHALLAN_DOWNLOAD')?.allowed_fields?.find((field) => field?.field_name === 'default_t_and_c')?.field_value : props?.selectedInvoice?.t_and_c) || '',
        gstNumber: edit ? props?.selectedInvoice?.gst_number : props?.selectedInvoice?.customer_info?.gst_number,
        accountManager: props?.selectedInvoice?.account_manager_id,
        deliveryDate: props?.selectedInvoice?.delivery_date ? dayjs(props?.selectedInvoice?.delivery_date) : dayjs(),
        dcDate: props?.selectedInvoice?.dc_date ? dayjs(props?.selectedInvoice?.dc_date) : dayjs(),
      };
    }
    if (!props.selectedSt && !props.selectedInvoice && !state.isUserReady && props?.cfV2DocDeliveryChallan?.data?.success) {
      const { user } = props;
      return {
        deliveryChallanLines: [
          {
            key: uuidv4(),
            quantity: null,
            uom_info: null,
            remarks: '',
            dc_quantity: null,
            product_sku_info: null,
            available_batches: [],
            total_available_batches_quantity: 0,
            hsn_code: '',
            tax_id: null,
            unit_price: null,
            showFreebie: false,
            lineCustomFields: state?.cfDeliveryChallanLine,
          },
        ],
        isUserReady: true,
        billingAddressId: user?.tenant_info?.default_billing_address_info?.address_id,
        billingAddress: user?.tenant_info?.default_billing_address_info,
        tenantDepartmentId: user?.tenant_info?.tenant_department_id,
        currentTenant: user?.tenant_info?.tenant_id,
      };
    }

    if (!state.t_and_c && !props.selectedInvoice) {
      if (props.docConfigDeliveryChallan) {
        const t_and_c = props.docConfigDeliveryChallan?.data?.find((item) => item?.document_type === 'DELIVERY_CHALLAN_DOWNLOAD')?.allowed_fields?.find((field) => field?.field_name === 'default_t_and_c')?.field_value;
        return {
          ...state,
          t_and_c: t_and_c,
        };
      }
    }

    return state;
  }

  getDCStatus = (approve) => {
    const { customStatusDeliveryChallan } = this.props;
    const status = {};
    if (approve) {
      const requiredStatus = customStatusDeliveryChallan?.statuses?.filter((dcStatus) => dcStatus?.type === 'CONFIRMED' && dcStatus?.is_default === true)?.[0];
      status.custom_status_id = requiredStatus?.custom_status_id;
      status.secondary_status = requiredStatus?.status_name;
    } else {
      const requiredStatus = customStatusDeliveryChallan?.statuses?.filter((dcStatus) => dcStatus?.type === 'DRAFT' && dcStatus?.is_default === true)?.[0];
      status.custom_status_id = requiredStatus?.custom_status_id;
      status.secondary_status = requiredStatus?.status_name;
    }
    return status;
  };

  addDC = (approve) => {
    const {
      billingAddress, billingAddressId, shippingAddress, shippingAddressId, deliveryChallanLines, t_and_c, initialDCNumber, dcNumber, docSeqId,
      dcDate, deliveryDate, cfDeliveryChallanDoc, selectedSellerInfo, selectedCustomer, selectedDestination, challanFor, currentTenantDepartment,
      gstNumber
    } = this.state;
    const { callback, edit, selectedInvoice, getDCByIdSuccess } = this.props;

    if (approve) {
      this.setState({ buttonClick: 'APPROVE', formSubmitted: true });
    } else {
      this.setState({ buttonClick: 'DRAFT', formSubmitted: true });
    }
    const isLineCfValid = () => {
      for (let i = 0; i < deliveryChallanLines?.length; i++) {
        if (!CustomFieldHelpers.isCfValid(deliveryChallanLines[i]?.lineCustomFields)) {
          return false;
        }
      }
      return true;
    };

    if (
      billingAddress
      && shippingAddress
      && dcDate
      && deliveryDate
      && dcNumber
      && !deliveryChallanLines?.filter((item) => (item?.dc_quantity <= 0 || !item.tax_id))?.length
      && !cfDeliveryChallanDoc?.filter((customField) => customField.isRequired && customField.isActive && (customField?.fieldType === 'ATTACHMENT' ? !customField?.fieldValue?.length : !customField?.fieldValue))?.length
      && isLineCfValid()
    ) {
      if (edit) {
        const dcLinesUpdate = (window.location.href.includes('/stock-transfer') || deliveryChallanLines[0].stock_transfer_line_id) ? (
          deliveryChallanLines?.filter((item) => item.dc_quantity)?.map((st) => ({
            quantity: Number(st.dc_quantity || '0'),
            free_quantity: 0,
            stock_transfer_line_id: st.stock_transfer_line_id,
            product_sku_name: st?.tenant_product_info?.product_sku_name || st?.product_sku_name,
            tenant_product_id: st?.tenant_product_id,
            remarks: st.remarks,
            unit_price: Number(st.unit_price) || 0,
            tax_group_info: st.tax_info,
            tax_id: st.tax_id,
            line_discount_percentage: Number(st.discount) || 0,
            hsn_code: st?.hsn_code?.toString(),
            uom_info: Array.isArray(st?.uom_info) ? st?.uom_info : [st?.uom_info],
            uom_id: st?.uomId || st?.uom_id,
            custom_fields: CustomFieldHelpers.postCfStructure(st?.lineCustomFields),
          }))
        ) : (
          deliveryChallanLines?.filter((item) => item.dc_quantity)?.map((st) => ({
            remarks: st.remarks,
            quantity: Number(st.dc_quantity),
            free_quantity: Number(st?.dc_free_quantity || 0),
            invoice_line_id: st.invoice_line_id || undefined,
            product_sku_name: st?.tenant_product_info?.product_sku_name || st?.product_sku_name,
            tenant_product_id: st?.tenant_product_id,
            unit_price: Number(st.unit_price) || 0,
            tax_group_info: st.tax_info,
            tax_id: st.tax_id,
            line_discount_percentage: Number(st.discount) || 0,
            hsn_code: st?.hsn_code?.toString(),
            order_line_id: st?.order_line_id,
            uom_info: Array.isArray(st?.uom_info) ? st?.uom_info : [st?.uom_info],
            uom_id: st?.uomId || st?.uom_id,
            custom_fields: CustomFieldHelpers.postCfStructure(st?.lineCustomFields),
          })));
        const {
          selectedSt, user, updateDC, getDCById, cfV2DocDeliveryChallan,
        } = this.props;
        const Payload = selectedSt ? {
          delivery_challan_id: selectedSt?.delivery_challan_id,
          tenant_id: selectedSt.tenant_id,
          stock_transfer_id: selectedSt?.stock_transfer_id,
          source_address_id: billingAddressId,
          destination_address_id: shippingAddressId,
          status: approve ? 'CONFIRMED' : 'DRAFT',
          source_address: billingAddress,
          destination_address: shippingAddress,
          delivery_challan_lines: dcLinesUpdate,
          dc_date: dayjs(dcDate).format('YYYY/MM/DD'),
          delivery_date: dayjs(deliveryDate).format('YYYY/MM/DD'),
          t_and_c: global.isBlankString(t_and_c) ? '' : t_and_c,
          custom_fields: cfDeliveryChallanDoc?.length ? CustomFieldHelpers.postCfStructure(cfDeliveryChallanDoc) : [],
          dc_number: initialDCNumber?.toLowerCase()?.trim() === dcNumber?.toLowerCase()?.trim() ? null : dcNumber,
          gst_number: gstNumber,
          secondary_status: this.getDCStatus(approve)?.secondary_status,
          custom_status_id: this.getDCStatus(approve)?.custom_status_id,
        } : {
          delivery_challan_id: selectedInvoice?.delivery_challan_id,
          tenant_id: selectedInvoice?.tenant_id,
          invoice_id: selectedInvoice?.invoice_type === 'CONSUMPTION_ORDER' ? undefined : selectedInvoice?.invoice_id,
          consumption_order_id: selectedInvoice?.invoice_type === 'CONSUMPTION_ORDER' ? selectedInvoice?.invoice_id : undefined,
          order_id: selectedInvoice?.invoice_type === 'CONSUMPTION_ORDER' ? undefined : selectedInvoice?.order_id,
          customer_id: selectedInvoice?.customer_id,
          tenant_department_id: selectedInvoice?.tenant_department_id || currentTenantDepartment,
          source_address_id: billingAddressId,
          destination_address_id: shippingAddressId,
          status: approve ? 'CONFIRMED' : 'DRAFT',
          source_address: billingAddress,
          destination_address: shippingAddress,
          delivery_challan_lines: dcLinesUpdate,
          dc_date: dayjs(dcDate).format('YYYY/MM/DD'),
          delivery_date: dayjs(deliveryDate).format('YYYY/MM/DD'),
          t_and_c: global.isBlankString(t_and_c) ? '' : t_and_c,
          custom_fields: cfDeliveryChallanDoc?.length ? CustomFieldHelpers.postCfStructure(cfDeliveryChallanDoc) : [],
          dc_number: initialDCNumber?.toLowerCase()?.trim() === dcNumber?.toLowerCase()?.trim() ? null : dcNumber,
          gst_number: gstNumber,
          secondary_status: this.getDCStatus(approve)?.secondary_status,
          custom_status_id: this.getDCStatus(approve)?.custom_status_id,
        };
        updateDC(Payload, () => {
          if (callback) callback();
          else this.props.history.push('/inventory/delivery-challan');
        });

      } else {
        const dcLines = deliveryChallanLines?.map((st) => ({
          quantity: Number(st.dc_quantity || '0'),
          free_quantity: Number(st.dc_free_quantity || '0'),
          remarks: st.remarks,
          unit_price: Number(st.unit_price) || 0,
          tax_group_info: st.tax_info,
          tax_id: st.tax_id,
          line_discount_percentage: Number(st.discount) || 0,
          hsn_code: st?.hsn_code?.toString(),
          stock_transfer_line_id: st.stock_transfer_line_id,
          invoice_line_id: st.invoice_line_id,
          product_sku_name: st?.product_sku_info?.product_sku_name,
          tenant_product_id: st?.tenant_product_id,
          order_line_id: st?.order_line_id,
          uom_info: Array.isArray(st?.uom_info) ? st?.uom_info : [st?.uom_info],
          uom_id: st?.uomId || st?.uom_id,
          custom_fields: CustomFieldHelpers.postCfStructure(st?.lineCustomFields),
        }));
        const {
          selectedSt, createDC, user,
        } = this.props;

        const {
          currencyConversionRate, selectedCurrencyID,
        } = this.state;
        const payload = {
          tenant_id: selectedSt ? selectedSt?.source_department_info?.tenant_id : (selectedInvoice ? selectedInvoice?.tenant_id : user?.tenant_info?.tenant_id),
          invoice_id: selectedInvoice?.invoice_type === 'CONSUMPTION_ORDER' ? undefined : selectedInvoice?.invoice_id,
          consumption_order_id: selectedInvoice?.invoice_type === 'CONSUMPTION_ORDER' ? selectedInvoice?.invoice_id : undefined,
          order_id: selectedInvoice?.invoice_type === 'CONSUMPTION_ORDER' ? undefined : selectedInvoice?.order_id,
          customer_id: selectedInvoice?.customer_id,
          tenant_department_id: selectedInvoice?.tenant_department_id || currentTenantDepartment,
          adhoc_dc_dest_tenant_id: challanFor === 'INTERNAL' ? selectedDestination : undefined,
          adhoc_dc_seller_id: challanFor === 'VENDOR' ? selectedSellerInfo?.seller_id : undefined,
          adhoc_dc_customer_id: (challanFor === 'CUSTOMER' && !selectedSt && !selectedInvoice) ? selectedCustomer : undefined,
          stock_transfer_id: selectedSt?.stock_transfer_id,
          source_address_id: billingAddressId,
          destination_address_id: shippingAddressId,
          status: approve ? 'CONFIRMED' : 'DRAFT',
          source_address: billingAddress,
          destination_address: shippingAddress,
          delivery_challan_lines: dcLines,
          dc_date: dayjs(dcDate).format('YYYY/MM/DD'),
          delivery_date: dayjs(deliveryDate).format('YYYY/MM/DD'),
          t_and_c: global.isBlankString(t_and_c) ? '' : t_and_c,
          custom_fields: cfDeliveryChallanDoc?.length ? CustomFieldHelpers.postCfStructure(cfDeliveryChallanDoc) : [],
          org_currency_id: selectedCurrencyID,
          conversion_rate: currencyConversionRate,
          dc_number: initialDCNumber?.toLowerCase()?.trim() === dcNumber?.toLowerCase()?.trim() ? null : dcNumber,
          seq_id: docSeqId || null,
          gst_number: gstNumber,
          secondary_status: this.getDCStatus(approve)?.secondary_status,
          custom_status_id: this.getDCStatus(approve)?.custom_status_id,
        };
        createDC(payload, (dcData) => {
          if (callback) callback();
          else this.props.history.push(`/inventory/delivery-challan/view/${dcData?.delivery_challan?.delivery_challan_id}`);
        });
      }
    }
  };

  handleProductChange = (tenantSku, key, productData) => {
    const { deliveryChallanLines, tenantDepartmentId } = this.state;
    const {
      getProductById, user, selectedInvoice, selectedSt,
    } = this.props;
    const autoPrintDescription = user?.tenant_info?.global_config?.settings?.print_description_automatically;
    getProductById(selectedInvoice?.tenant_id || selectedSt?.tenant_id || user?.tenant_info?.tenant_id, tenantSku?.product_sku_id, tenantDepartmentId, (product) => {
      if (product?.product_type === 'BUNDLE' && product?.bundle_products?.length === 0) {
        notification.open({
          message: 'This product is a bundle but it does not have any child components.',
          duration: 4,
          type: 'error',
          placement: 'top',
        });
      } else {
        const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
        for (let i = 0; i < copyData?.length; i++) {
          if (copyData[i].key === key) {
            const parentKey = uuidv4();
            const copyDataItem = copyData[i];
            copyDataItem.key = parentKey;
            copyDataItem.tenant_product_id = product?.tenant_product_id;
            copyDataItem.product_sku_name = product?.product_info.product_sku_name;
            copyDataItem.unitPrice = product?.selling_price || 0;
            copyDataItem.unit_price = product?.selling_price || 0;
            copyDataItem.sku = product?.product_info?.product_sku_id || '';
            copyDataItem.hsn_code = product?.product_info?.hsn_code || '';
            copyDataItem.taxInfo = product?.tax_info;
            copyDataItem.tax_info = product?.tax_info;
            copyDataItem.tax_id = product?.product_info?.tax_id;
            copyDataItem.lot = product?.total_price || 0;
            copyDataItem.uomId = product?.product_info?.uom_id || 0;
            copyDataItem.uom_info = product?.uom_info;
            copyDataItem.uomGroup = product?.group_id;
            copyDataItem.expiry_days = product?.product_info?.expiry_days;
            copyDataItem.quantity = 0;
            copyDataItem.dc_quantity = 0;
            copyDataItem.remarks = autoPrintDescription ? (productData?.description || '')?.replace(/<[^>]+>/g, '') : '';
            // eslint-disable-next-line no-loop-func
            copyDataItem.bundle_products = product?.bundle_products?.map((item) => ({
              ...item,
              key: uuidv4(),
              parentKey,
              unitPrice: QUANTITY(item?.unit_price),
              uomId: Number(item?.bundle_uom_id),
              uomGroup: Number(item?.group_id),
              uom_info: item?.bundle_uom_info,
              taxId: Number(item?.tax_id),
              taxInfo: item?.tax_info,
              tax_info: item?.tax_info,
              product_sku_name: item?.product_info?.product_sku_name,
              quantity: item?.quantity,
              expiry_days: item?.product_info?.expiry_days,
              product_sku_info: item?.product_info,
            }));
            copyDataItem.product_sku_info = {
              ...product?.product_info,
              expiry_days: product?.product_info?.expiry_days,
              uom_info: product?.uom_info,
            };
            copyDataItem.product_category_info = product?.product_category_info;
            copyDataItem.lineCustomFields = copyDataItem?.lineCustomFields?.map((i) => ({
              ...i,
              fieldValue: i?.fieldName === 'Rate' ? product?.selling_price || 0 : (i?.fieldName === 'Quantity' ? 0 : i?.fieldValue),
            }));
            copyData[i] = copyDataItem;
          }
        }
        this.setState({ deliveryChallanLines: copyData });
      }
    });
  };

  handleProductChangeValue = (value, key) => {
    const { deliveryChallanLines } = this.state;
    const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
    for (let i = 0; i < copyData?.length; i++) {
      if (copyData[i].key === key) {
        const copyDataItem = copyData[i];
        copyDataItem.product_sku_name = value;
        copyData[i] = copyDataItem;
      }
    }
    this.setState({ deliveryChallanLines: copyData });
  };

  getAddressEntity = () => {
    const {
      selectedAddressType,
      selectedDestination,
      challanFor,
      selectedCustomer,
      selectedSeller,
      selectedSellerInfo,
      currentTenantDepartment,
    } = this.state;

    const {
      selectedInvoice,
      selectedSt,
      edit,
      user,
    } = this.props;

    if (selectedAddressType === 'SHIPPING') {
      if (selectedSt) {
        if (edit) {
          return {
            entityId: selectedSt?.destination_tenant_department_info?.tenant_id,
            entityType: 'TENANT',
          };
        }
        return {
          entityId: selectedSt?.destination_department_info?.tenant_id,
          entityType: 'TENANT',
        };
      }
      if (selectedInvoice) {
        return {
          entityId: selectedInvoice?.customer_id || selectedInvoice?.adhoc_dc_customer_id || selectedInvoice?.adhoc_dc_dest_tenant_id || selectedInvoice?.adhoc_dc_seller_id,
          entityType: (selectedInvoice?.customer_id || selectedInvoice?.adhoc_dc_customer_id) ? 'CUSTOMER' : (selectedInvoice?.adhoc_dc_dest_tenant_id ? 'TENANT' : 'SELLER'),
        };
      }

      if (challanFor === 'CUSTOMER') {
        return { entityId: selectedCustomer, entityType: 'CUSTOMER' };
      }

      if (challanFor === 'VENDOR') {
        return { entityId: selectedSellerInfo?.seller_id, entityType: 'SELLER' };
      }

      return { entityId: selectedDestination, entityType: 'TENANT' };
    }

    if (selectedAddressType === 'BILLING') {
      if (selectedSt) {
        return {
          entityId: edit ? selectedSt?.source_tenant_department_info?.tenant_id : selectedSt?.source_department_info?.tenant_id,
          entityType: 'TENANT',
        };
      }

      return {
        entityId: selectedInvoice ? selectedInvoice?.tenant_configuration?.tenant_id : user?.tenant_info?.tenant_id,
        entityType: 'TENANT',
      };
    }
  };

  addNewRow = () => {
    const { deliveryChallanLines } = this.state;
    const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
    copyData.push({
      key: uuidv4(),
      lineCustomFields: this.state?.cfDeliveryChallanLine || [],
    });
    this.setState({ deliveryChallanLines: copyData });
  };

  handleDelete = (selectedKey) => {
    const { deliveryChallanLines } = this.state;
    if (deliveryChallanLines?.length > 1) {
      const copyData = window.location.href.includes('/stock-transfer') ? deliveryChallanLines.filter((item) => item?.key !== selectedKey) : deliveryChallanLines.filter((item) => item?.key !== selectedKey);
      this.setState({ deliveryChallanLines: copyData });
    } else {
      notification.open({
        type: 'error',
        message: 'You need to have at least one item in the delivery challan.',
        duration: 4,
        placement: 'top',
      });
    }
  };

  customInputChange(fieldValue, cfId) {
    const { cfDeliveryChallanDoc } = this.state;
    const newCustomField = cfDeliveryChallanDoc?.map((customField) => {
      if (customField?.cfId === cfId) {
        if (customField?.fieldType === 'ATTACHMENT' && customField?.entity_name === 'DELIVERY_CHALLAN') {
          return {
            ...customField,
            fieldValue: fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
            })),
          };
        }
        return {
          ...customField,
          fieldValue,
        };
      }
      return {
        ...customField,
      };
    });
    this.setState({
      cfDeliveryChallanDoc: newCustomField,
    });
  }

  getColumns = () => {
    const { visibleColumns, cfDeliveryChallanLine, formSubmitted } = this.state;
    const { priceMasking, selectedInvoice, selectedSt, edit } = this.props;
    const { isDataMaskingPolicyEnable, isHideSellingPrice } = priceMasking;
    let dcColumns =
    [
      {
        title: 'Product',
        render: (text, record) => {
          const { deliveryChallanLines, formSubmitted } = this.state;
          const productInfo = record?.product_sku_info || record?.tenant_product_info;
          return (
            <div className="invoice-table__product-name">
              {productInfo ? (
                <React.Fragment>
                  <Link
                    to={`/inventory/product/view/${productInfo?.product_sku_id}`}
                    target="_blank"
                  >
                    {`#${productInfo?.internal_sku_code}`}
                  </Link>
                  <H3Text text={productInfo?.product_sku_name} className="" />
                  {record?.product_category_info &&
                    record?.product_category_info?.category_path?.length >
                    0 && (
                    <ProductCategoryLabel
                      categoryPath={
                        record?.product_category_info?.category_path
                      }
                      categoryName={record?.product_category_info?.category_path?.at(
                        -1
                      )}
                      containerStyle={{
                        width: "fit-content",
                      }}
                    />
                  )}
                  <textarea
                    value={record?.remarks?.replace(/<[^>]+>/g, '')}
                    onChange={(event) => {
                      const copyData = JSON.parse(
                        JSON.stringify(deliveryChallanLines)
                      );
                      const updatedData = copyData.map((obj) => {
                        if (obj.key === record.key) {
                          return { ...obj, remarks: event.target.value };
                        }
                        return obj;
                      });
                      this.setState({
                        deliveryChallanLines: updatedData,
                      });
                    }}
                    className="invoice-table__remarks"
                    placeholder="Add description of this item.."
                  />
                  <div style={{ display: "flex" }}>
                    <div style={{ marginTop: "2px" }}>
                      {record?.product_sku_info?.product_type ===
                      "BUNDLE" && (
                        <H3Text
                          text="Bundle"
                          className="table-subscript table-subscript-tag"
                        />
                      )}
                      {record?.product_sku_info?.product_type ===
                      "SERVICE" && (
                        <H3Text
                          text="Service"
                          className="table-subscript table-subscript-tag"
                        />
                      )}
                      {!["SERVICE", "BUNDLE"].includes(
                        record?.product_sku_info?.product_type
                      ) && (
                        <H3Text
                          text="Goods"
                          className="table-subscript table-subscript-tag"
                        />
                      )}
                    </div>
                    <div className="invoice-table__hsn">
                      <H3Text
                        text={
                          record?.product_sku_info?.product_type === "SERVICE"
                            ? "SAC Code"
                            : "HSN Code"
                        }
                        className="invoice-table__hsn-label"
                      />
                      <div className="invoice-table__hsn-value">
                        <input
                          value={record.hsn_code}
                          onChange={(event) => {
                            const copyData = JSON.parse(
                              JSON.stringify(deliveryChallanLines)
                            );
                            const updatedData = copyData.map((obj) => {
                              if (obj.key === record.key) {
                                return {
                                  ...obj,
                                  hsn_code: event.target.value,
                                };
                              }
                              return obj;
                            });
                            this.setState({
                              deliveryChallanLines: updatedData,
                            });
                          }}
                          className="invoice-table__remarks"
                          maxLength="10"
                        />
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <ProductFilterV2
                  record={record}
                  productTypes={["NON_STORABLE", "STORABLE", "SERVICE"]}
                  handleProductChangeValue={this.handleProductChangeValue}
                  handleProductChange={this.handleProductChange}
                  required
                  showError={!record.product_sku_id && formSubmitted}
                  isTextarea
                  onClear={(key) => {
                    const copyData = JSON.parse(
                      JSON.stringify(deliveryChallanLines)
                    );
                    const updatedData = copyData.map((item) => {
                      if (item.key === key) {
                        return {
                          ...item,
                          tenant_product_id: null,
                          product_sku_id: null,
                          product_sku_name: "",
                          product_sku_info: null,
                          asset1: "",
                          vendorMoq: null,
                          lastUpdatedPrice: null,
                          sku: null,
                          quantity: "",
                          uomId: null,
                          taxId: null,
                          price: "",
                        };
                      }
                      return {
                        ...item,
                      };
                    });
                    this.setState({
                      deliveryChallanLines: updatedData,
                    });
                  }}
                  excludedProducts={
                    deliveryChallanLines.map((item) =>
                      JSON.stringify(item?.tenant_product_id)
                    ) || []
                  }
                  disabled={record?.product_sku_id}
                  showClear
                />
              )}
            </div>
          );
        },
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: 'Transfer Quantity',
        render: (item) => (`${QUANTITY(item?.quantity) || '-'} ${item?.uom_info?.[0]?.uqc?.toProperCase() || item?.product_sku_info?.uom_info?.uqc?.toProperCase() || item?.tenant_product_info?.uqc?.toProperCase() || '-'} `),
        visible: visibleColumns?.TRANSFER_QUANTITY?.visible,
      },
      {
        title: 'Invoice Quantity',
        render: (item) => (
          <div>
            {Number(item?.quantity) > 0 ? `${QUANTITY(item?.quantity)}  ${item?.uom_info?.[0]?.uqc?.toProperCase() || item?.product_sku_info?.uom_info?.uqc?.toProperCase() || item?.tenant_product_info?.uqc?.toProperCase() || '-'}` : '-'}
            {Number(item?.free_quantity) > 0 ? <H3Text text={`+ ${item?.uom_info?.[0]?.uqc?.toProperCase() || item?.free_quantity} ${item?.product_sku_info?.uom_info?.uqc?.toProperCase() || item?.tenant_product_info?.uqc?.toProperCase() || '-'} Free`} className="table-subscript" /> : ''}
          </div>
        ),
        visible: visibleColumns?.INVOICE_QUANTITY?.visible,
      },
      {
        title: 'Quantity',
        render: (item) => {
          const { deliveryChallanLines, createDCLoading, updateDCLoading } = this.state;
          const { formSubmitted } = this.state;
          const { user } = this.props;

          return (
            <Fragment>
              <div className={`orgFormContainer ${formSubmitted && (!item?.dc_quantity || Number(item?.dc_quantity) <= 0) ? 'form-error__input' : ''}`}>
                <H3FormInput
                  labelClassName="orgFormLabel"
                  inputClassName={`orgFormInput ${Number(item.dc_quantity < 0) ? 'orgFormInputError' : ''} `}
                  value={item.dc_quantity}
                  name="quantity"
                  type="number"
                  disabled={createDCLoading || updateDCLoading}
                  showError={formSubmitted && item?.product_sku_info && item.dc_quantity <= 0}
                  required
                  onChange={(event) => {
                    const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
                    const updatedData = copyData.map((obj) => {
                      if (obj.key === item.key) {
                        return {
                          ...obj,
                          dc_quantity: event.target.value,
                          lineCustomFields: obj?.lineCustomFields?.map((i) => ({
                            ...i,
                            fieldValue: i?.fieldName === 'Quantity' ? event.target.value : i?.fieldValue,
                          })),
                        };
                      }
                      return obj;
                    });
                    this.setState({
                      deliveryChallanLines: updatedData,
                    });
                  }}
                />
                {item?.product_sku_info && !user?.tenant_info?.inventory_config?.settings?.enable_batch_consumed_qty_editable && (
                  <div className="freebie-container">
                    <div
                      className="freebie-cta"
                      onClick={(event) => {
                        const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
                        const updatedData = copyData.map((obj) => {
                          if (obj.key === item.key) {
                            return {
                              ...obj,
                              showFreebie: true,
                            };
                          }
                          return obj;
                        });
                        this.setState({
                          deliveryChallanLines: updatedData,
                        });
                      }}
                    >
                      + Add Free Qty
                    </div>
                    {item?.showFreebie && (
                      <div className="freebie-input">
                        <H3FormInput
                          value={item.dc_free_quantity}
                          type="number"
                          containerClassName={`orgInputContainer ${(formSubmitted && Number(item.dc_free_quantity) < 0) ? 'create-pr__input' : ''}`}
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput"
                          onChange={(event) => {
                            const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
                            const updatedData = copyData.map((obj) => {
                              if (obj.key === item.key) {
                                return {
                                  ...obj,
                                  dc_free_quantity: event.target.value,
                                };
                              }
                              return obj;
                            });
                            this.setState({
                              deliveryChallanLines: updatedData,
                            });
                          }}
                        />
                        <CloseOutlined onClick={() => {
                          const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
                          const updatedData = copyData.map((obj) => {
                            if (obj.key === item.key) {
                              return {
                                ...obj,
                                showFreebie: false,
                                dc_free_quantity: 0,
                              };
                            }
                            return obj;
                          });
                          this.setState({
                            deliveryChallanLines: updatedData,
                          });
                        }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Fragment>
          );
        },
        visible: visibleColumns?.QUANTITY?.visible,
      },
      {
        title: 'Rate',
        render: (text, record) => {
          const { deliveryChallanLines, formSubmitted } = this.state;
          return (
            <div>
              <H3FormInput
                value={record.unit_price}
                type="number"
                containerClassName={` ${(formSubmitted && Number(record.unit_price) < 0) ? 'create-pr__input' : ''}`}
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onWheel={(event) => event.target.blur()}
                onChange={(event) => {
                  const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
                  const updatedData = copyData.map((obj) => {
                    if (obj.key === record.key) {
                      return { ...obj, unit_price: event.target.value, lineCustomFields: obj?.lineCustomFields?.map((i) => ({
                        ...i,
                        fieldValue: i?.fieldName === 'Rate' ? event.target.value : i?.fieldValue,
                      })),
                      };
                    }
                    return obj;
                  });
                  this.setState({
                    deliveryChallanLines: updatedData,
                  });
                }}
                hideInput={isDataMaskingPolicyEnable && isHideSellingPrice}
                popOverMessage="You don't have access to view/edit price"
              />
            </div>
          );
        },
        visible: visibleColumns?.RATE?.visible,
      },
      {
        title: 'Tax',
        render: (text, record) => {
          const { deliveryChallanLines, formSubmitted } = this.state;
          return (
            <div style={{ width: '120px' }} className={`orgFormContainer ${(formSubmitted && !record.tax_id) ? 'orgFormInputError' : ''}`}>
              <SelectTax
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
                  const updatedData = copyData.map((obj) => {
                    if (obj.key === record.key) {
                      return {
                        ...obj,
                        tax_id: value?.tax_id,
                        tax_info: value,
                      };
                    }
                    return obj;
                  });
                  this.setState({
                    deliveryChallanLines: updatedData,
                  });
                }}
                errorOutline={formSubmitted && !record.tax_id && record?.product_sku_id}
                selectedGST={record.tax_id}
              />
            </div>
          );
        },
        visible: visibleColumns?.TAX?.visible,
      },
      {
        title: 'Discount %',
        width: '100px',
        render: (text, record) => {
          const { deliveryChallanLines } = this.state;
          return (
            <div>
              <H3FormInput
                value={record.discount}
                type="number"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(event) => {
                  const copyData = JSON.parse(JSON.stringify(deliveryChallanLines));
                  const updatedData = copyData.map((obj) => {
                    if (obj.key === record.key) {
                      return { ...obj, discount: event.target.value };
                    }
                    return obj;
                  });
                  this.setState({
                    deliveryChallanLines: updatedData,
                  });
                }}
              />
            </div>
          );
        },
        visible: visibleColumns?.DISCOUNT?.visible,
      },
      {
        title: 'Total',
        render: (text, record) => {
          const { MONEY } = this.props;
          const { selectedCurrencyName, billingAddress, shippingAddress } = this.state;
          const taxableValue = ((record.dc_quantity) * record.unit_price) * (record.discount ? Number(100 - record.discount) / 100 : 1) || 0;
          return (
            <div style={{ width: '100px' }}>
              {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view total price"} /> : (record.tax_info
                ? MONEY(Helpers.computeTaxation(taxableValue, record.tax_info, shippingAddress?.state, billingAddress?.state)?.taxed_value, selectedCurrencyName?.currency_code) : 0)}
            </div>
          );
        },
        visible: visibleColumns?.TOTAL?.visible,
      },
      {
        title: '',
        fixed: 'right',
        render: (text, record) => (
          <Fragment>
            <div className="delete-line-button" onClick={() => this.handleDelete(record?.key)}>
              <CloseOutlined />
            </div>
          </Fragment>
        ),
        visible: true,
      },
    ];
    if(cfDeliveryChallanLine?.length) {
      dcColumns.splice(4, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfDeliveryChallanLine, visibleColumns, this.customLineInputChange, formSubmitted, '', '', '', '', '', '', edit, ((selectedSt || selectedInvoice) && !edit)));
    }

    return dcColumns.filter((item) => item.visible);
  };

  customLineInputChange = (fieldValue, key) => {
    const { deliveryChallanLines } = this.state;
    const copyData = structuredClone(deliveryChallanLines);
    for (const copyDataItem of copyData) {
      if (copyDataItem?.key === key) {
        copyDataItem.lineCustomFields = fieldValue;
        const qtyCf = fieldValue?.find((j) => j?.fieldName === 'Quantity');
        copyDataItem.dc_quantity = qtyCf?.fieldValue > 0 ? Number.parseFloat(Number(qtyCf?.fieldValue).toFixed(DEFAULT_CUR_ROUND_OFF)) : '';
      }
    }
    this.setState({ deliveryChallanLines: copyData });
  };

  render() {
    const {
      selectedSt, selectedInvoice, createDCLoading, edit, updateDCLoading, documentType, user, getDocConfigDeliveryChallanLoading, disableCaseForGST
    } = this.props;
    const {
      shippingAddressId, billingAddressId, formSubmitted, shippingAddress, billingAddress, showAddressDrawer, selectedAddressType,
      dcColumns, deliveryChallanLines, dcDate, cfDeliveryChallanDoc, challanFor, deliveryDate,
      currentTenant, selectedCustomer, selectedSeller, selectedDestination, currentTenantDepartment, t_and_c, dcNumber, docSeqId, gstNumber, buttonClick,visibleColumns, cfDeliveryChallanLine,
    } = this.state;

    const deliveryChallan = user?.tenant_info?.inventory_config?.sub_modules?.delivery_challan?.is_active;

    return (
      <div className={window.location.pathname === '/inventory/delivery-challan/create' ? '' : 'create-dc__wrapper'}>
        <Drawer
          open={showAddressDrawer}
          onClose={() => this.setState({ showAddressDrawer: false, selectedAddressType: '' })}
          width="360"
          destroyOnClose
        >
          <AddressSelector
            title={selectedAddressType === 'SHIPPING' ? 'Shipping Address' : 'Source Address'}
            selectedAddressId={selectedAddressType === 'SHIPPING' ? shippingAddressId : billingAddressId}
            onAddressChange={(address) => {
              if (selectedAddressType === 'SHIPPING') {
                this.setState({ shippingAddress: address, showAddressDrawer: false, shippingAddressId: address.address_id });
              }
              if (selectedAddressType === 'BILLING') {
                this.setState({ billingAddress: address, showAddressDrawer: false, billingAddressId: address.address_id });
              }
            }}
            entityId={this.getAddressEntity()?.entityId}
            entityType={this.getAddressEntity()?.entityType}
            documentType={documentType}
            tenantId={currentTenant}
          />

        </Drawer>

        <div className="form__wrapper">
          <div className="form__section">
            <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
              <H3Text text="PART A" className="form__section-title" />
              <div className="form__section-line" />
              <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                <div style={{ marginLeft: '5px', textAlign: 'right' }}>
                  {/* {documentType === 'Invoice' && (
                    <Select
                      onChange={(value) => {
                        const selectedCurrency = CurrenciesResults?.find(
                          (currency) => currency?.org_currency_id === value,
                        );
                        this.setState({
                          selectedCurrencyID: value,
                          selectedCurrencyName: selectedCurrency,
                          selectedCurrencyConversionRate: selectedCurrency?.conversion_rate,
                        });
                      }}
                      value={selectedCurrencyID}
                      style={{
                        width: '110px',
                        marginLeft: 'auto',
                      }}
                      bordered={false}
                      className="currency__selector"
                      loading={getCurrenciesLoading}
                      disabled={selectedInvoice || getCurrenciesLoading}
                      options={CurrenciesResults?.map((currency) => ({
                        value: currency?.org_currency_id, // Use a unique identifier as the value
                        label: `${currency.currency_code} (${currency.currency_symbol})`,
                      }))}
                    />
                  )} */}
                </div>
              </div>
            </div>
          </div>
          <div className="form__section-inputs mg-bottom-20">
            <div className="ant-row">
              <DocumentNumberSeqInput
                valueFromProps={dcNumber}
                updateCase={edit}
                setInitialDocSeqNumber={(value) => this.setState({ initialDCNumber: value })}
                entityName="DELIVERY_CHALLAN"
                docSeqId={docSeqId}
                tenantId={currentTenant}
                onChangeFromProps={(event, newValue, seqId) => {
                  this.setState({
                    dcNumber: newValue ? (newValue || '') : (event?.target?.value || ''),
                    docSeqId: seqId,
                  });
                }}
                docTitle="Delivery Challan#"
                formSubmitted={formSubmitted}
              />
              {selectedInvoice?.adhoc_dc_customer_id && (
                <div className="ant-col-md-6">
                  <div className="form__input-row" style={{ marginBottom: '10px' }}>
                    <Fragment>
                      <H3Text className="form__input-row__label" text="Customer" />
                      <H3Text className="form__input-row__text" text={selectedInvoice?.adhoc_dc_customer_info?.customer_name} />
                    </Fragment>
                  </div>
                </div>
              )}
              {selectedInvoice?.adhoc_dc_seller_id && (
                <div className="ant-col-md-6">
                  <div className="form__input-row" style={{ marginBottom: '10px' }}>
                    <Fragment>
                      <H3Text className="form__input-row__label" text="Vendor" />
                      <H3Text className="form__input-row__text" text={`${selectedInvoice?.adhoc_dc_seller_info?.internal_slr_code} - ${selectedInvoice?.adhoc_dc_seller_info?.seller_name}`} />
                    </Fragment>
                  </div>
                </div>
              )}
              {selectedInvoice?.adhoc_dc_dest_tenant_id && (
                <div className="ant-col-md-6">
                  <div className="form__input-row" style={{ marginBottom: '10px' }}>
                    <Fragment>
                      <H3Text className="form__input-row__label" text="Customer" />
                      <H3Text className="form__input-row__text" text={selectedInvoice?.adhoc_dc_dest_tenant_info?.tenant_name} />
                    </Fragment>
                  </div>
                </div>
              )}
              {(!selectedSt && !selectedInvoice) ? (
                <div className="ant-col-md-6">
                  <div className="form__input-row">
                    <label className="form__input-row__label">
                      Delivery For
                    </label>
                    <div className="form__input-row__input">
                      <PRZSelect
                        value={challanFor}
                        filterOption={false}
                        onChange={(value) => this.setState({
                          challanFor: value,
                          shippingAddress: null,
                          shippingAddressId: null,
                          gstNumber: '',
                          selectedCustomer: null,
                          selectedSeller: null,
                          selectedDestination: null,
                          selectedCustomerInfo: null,
                          selectedSellerInfo: null,
                        })}
                        allowClear
                      >
                        <Option key="CUSTOMER" value="CUSTOMER">Customer</Option>
                        <Option key="VENDOR" value="VENDOR">Vendor</Option>
                        <Option key="INTERNAL" value="INTERNAL">Internal Location</Option>
                      </PRZSelect>
                    </div>
                  </div>
                </div>
              ) : ''}
              {challanFor === 'CUSTOMER' && (!selectedInvoice?.adhoc_dc_customer_id) && !edit && (
                <div className="ant-col-md-6">
                  <SelectCustomer
                    title="Select Customer"
                    selectedCustomer={selectedCustomer}
                    onChange={(value) => {
                      this.setState({
                        selectedCustomer: value?.customer_id,
                        shippingAddress: value?.customer_info?.shipping_address_details,
                        shippingAddressId: value?.customer_info?.shipping_address_details?.address_id,
                        gstNumber: value?.customer_info?.gst_number,
                        selectedCustomerInfo: value?.customer_info,
                      });
                      this.getAddressEntity();
                    }}
                    disabled={createDCLoading || updateDCLoading || selectedInvoice}
                    labelClassName="form__input-row__label"
                    inputClassName={`${formSubmitted && !selectedCustomer ? 'form__input__select-error' : 'form__input-row__input'}`}
                    containerClass="form__input-row"
                    showError={formSubmitted && !selectedCustomer && challanFor === 'CUSTOMER'}
                    required
                  />
                </div>
              )}
              {
                challanFor === 'VENDOR'
                && (
                  <div className="ant-col-md-6">
                    <SelectSeller
                      selectedSeller={selectedSeller}
                      onChange={(value) => {
                        this.setState({
                          selectedSeller: value?.tenant_seller_id,
                          selectedSellerInfo: value?.seller_info,
                          gstNumber: value?.seller_info?.gst_number,
                          shippingAddress: value?.seller_info?.office_address_details,
                          shippingAddressId: value?.seller_info?.office_address_details?.address_id,
                        });
                        this.getAddressEntity();
                      }}
                      labelClassName="form__input-row__label"
                      inputClassName={`form__input-row__input ${formSubmitted && !selectedSeller ? 'form__input-row__input-error' : ''}`}
                      containerClass="form__input-row"
                      showError={formSubmitted && !selectedSeller && challanFor === 'VENDOR'}
                    />
                  </div>
                )
              }
              {
                (challanFor === 'INTERNAL' || challanFor === 'INTERNAL_STOCK_TRANSFER') && (
                  <div className="ant-col-md-6">
                    <TenantSelector
                      title="Select Location"
                      selectedTenant={selectedDestination}
                      showSearch={false}
                      onChange={(value) => {
                        const tenantInfo = user?.user_tenants?.filter((item) => item?.tenant_id === value);
                        this.setState({
                          selectedDestination: value,
                          gstNumber: tenantInfo?.[0]?.gst_number,
                          shippingAddress: tenantInfo[0]?.default_shipping_address_info,
                          shippingAddressId: tenantInfo[0]?.default_shipping_address_info?.address_id,
                        });
                        this.getAddressEntity();
                      }}
                      placeholder="Select Business Unit"
                      labelClassName="form__input-row__label"
                      inputClassName={`${formSubmitted && !selectedDestination ? 'form__input-row__input-error' : 'form__input-row__input'}`}
                      containerClassName="form__input-row"
                      noDropdownAlign
                      disabled={createDCLoading || updateDCLoading || challanFor === 'INTERNAL_STOCK_TRANSFER'}
                    />
                    {formSubmitted && challanFor === 'INTERNAL' && !selectedDestination && (
                      <div className="input-error">*Please select a location</div>
                    )}
                  </div>
                )
              }
              <div className="ant-col-md-6">
                <div className="form__input-row">
                  <H3Text text="Delivery Challan Date" required className="form__input-row__label" />
                  <div className={`form__input-row__input ${formSubmitted && !dcDate ? 'form__input-row__input-error' : ''}`}>
                    <DatePicker
                      style={{
                        width: '100%',
                      }}
                      disabled={createDCLoading || updateDCLoading}
                      value={dcDate}
                      onChange={(value) => {
                        this.setState({ dcDate: value });
                      }}
                      format="DD-MMM-YYYY"
                    />
                    {formSubmitted && !dcDate && <div style={{ color: 'red', fontSize: '11px' }}>*Please select the  date</div>}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-6">
                <div className="form__input-row">
                  <H3Text text="Delivery Date" required className="form__input-row__label" />
                  <div className={`form__input-row__input ${formSubmitted && !deliveryDate ? 'form__input-row__input-error' : ''}`}>
                    <DatePicker
                      style={{
                        width: '100%',
                      }}
                      disabled={createDCLoading || updateDCLoading}
                      value={deliveryDate}
                      onChange={(value) => {
                        this.setState({ deliveryDate: value });
                      }}
                      format="DD-MMM-YYYY"
                    />
                    {formSubmitted && !deliveryDate && <div style={{ color: 'red', fontSize: '11px' }}>*Please select the date</div>}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-6">
                <div className="form__input-row">
                  <H3Text text="Select Department" required className="form__input-row__label" />
                  <div className="form__input-row__input">
                    <SelectDepartment
                      title="Select Department"
                      selectedDepartment={currentTenantDepartment}
                      onChange={(value) => {
                        this.setState({
                          currentTenantDepartment: value?.tenant_department_id,
                        });
                      }}
                      hideTitle
                      disabled={selectedInvoice}
                      labelClassName="orgFormLabel"
                      inputClassName="empty-class"
                      tenentLevelDepartment
                      emptyNotAllowed
                      tenantId={currentTenant}
                    />
                    {formSubmitted && !currentTenantDepartment && <div className="input-error">*Please select the Department</div>}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-6">
                <div className="form__input-row">
                  <H3Text
                    text="GST Number"
                    className="form__input-row__label"
                  />
                  <H3FormInput
                    name="a valid GST Number"
                    type="text"
                    containerClassName="orgInputContainer form__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) =>
                      this.setState({ gstNumber: e.target.value })
                    }
                    value={gstNumber}
                    showError={
                      formSubmitted &&
                      (gstNumber
                        ? String(gstNumber)?.length !== 15
                        : false)
                    }
                    disabled={
                      createDCLoading ||
                      updateDCLoading
                      || disableCaseForGST
                    }
                  />
                </div>
              </div>
              {/* <div className="ant-col-md-6">
                <div className="form__input-row">
                  <H3Text text="Sales Manager" className="form__input-row__label" />
                  <div className="form__input-row__input">
                    <SelectAppUser
                      hideTitle
                      containerClassName="orgInputContainer"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      selectedUser={accountManager}
                      onChange={(value) => {
                        this.setState({ accountManager: value })
                      }}
                      disabled={createDCLoading || updateDCLoading}
                    />
                  </div>
                </div>
              </div> */}
              <CustomFieldV3
                customFields={cfDeliveryChallanDoc}
                formSubmitted={formSubmitted}
                customInputChange={(value, cfId) => this.customInputChange(value, cfId)}
                wrapperClassName="ant-col-md-6"
                containerClassName="form__input-row"
                labelClassName="form__input-row__label"
                inputClassName="form__input-row__input"
                errorClassName="form__input-row__input-error"
                disableCase={createDCLoading || updateDCLoading}
                hideTitle
                isUpdate={edit}
                isCarryForward={selectedInvoice || selectedSt && !edit}
              />
            </div>
          </div>

          <div className="form__section">
            <div className="form__section-inputs">
              <div className="ant-row">
                <div className="ant-col-md-8">
                  <div className="form__input-row" style={{ marginTop: '5px' }}>
                    <label className="form__input-row__label">
                      Select Source Address
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                    <div className="form__input-row__address__wrapper">
                      <div className="form__input-row__address">
                        {billingAddress && (
                          <div className="form__input-row__address-info">
                            <div className="form__input-row__address-l1">{billingAddress?.address1}</div>
                            <div
                              className="form__input-row__address-l2"
                            >
                              {`${billingAddress?.city}, ${billingAddress?.state} ${billingAddress?.postal_code}`}
                            </div>
                          </div>
                        )}
                        {!billingAddress
                          && <H3Text text="Select address.." className="form__input-row__address-placeholder" />}
                        <div
                          className="form__input-row__address-icon"
                          onClick={() => this.setState({ selectedAddressType: 'BILLING', showAddressDrawer: true })}
                        >
                          <EditFilled />
                          {' '}
                          Update
                        </div>
                      </div>
                      {formSubmitted && !billingAddress && <div className="input-error">*Please select a address</div>}
                    </div>
                  </div>
                </div>
                <div className="ant-col-md-8">
                  <div className="form__input-row">
                    <label className="form__input-row__label">
                      Select Shipping Address
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                    <div className="form__input-row__address__wrapper">
                      <div className="form__input-row__address" style={{ marginBottom: '5px' }}>
                        {shippingAddress && (
                          <div className="form__input-row__address-info">
                            <div className="form__input-row__address-l1">{shippingAddress?.address1}</div>
                            <div
                              className="form__input-row__address-l2"
                            >
                              {`${shippingAddress?.city}, ${shippingAddress?.state} ${shippingAddress?.postal_code}`}
                            </div>
                          </div>
                        )}
                        {!shippingAddress
                          && <H3Text text="Select address.." className="form__input-row__address-placeholder" />}
                        <div
                          className="form__input-row__address-icon"
                          onClick={() => {
                            this.setState({ selectedAddressType: 'SHIPPING' });
                            if (selectedSt || selectedInvoice) {
                              this.setState({ showAddressDrawer: true });
                            } else if ((challanFor === 'CUSTOMER' ? selectedCustomer : challanFor === 'VENDOR' ? selectedSeller : selectedDestination)) {
                              this.setState({ showAddressDrawer: true });
                            } else {
                              notification.open({
                                type: 'error',
                                message: `Please select the ${challanFor === 'VENDOR' ? 'Vendor' : challanFor === 'INTERNAL' ? 'Location' : 'Customer'} to update the address.`,
                                duration: 4,
                                placement: 'top',
                              });
                            }
                          }}
                        >
                          <EditFilled />
                          &nbsp;Update
                        </div>
                      </div>
                      {formSubmitted && !shippingAddress && <div className="input-error">*Please select a address</div>}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <Table
            bordered
            showHeader
            loading={createDCLoading || updateDCLoading}
            title={() => (
              <div className="dc-form-table__header">
                <H3Text
                  text={`Delivery Challan Line Items (${deliveryChallanLines?.length || '0'})`}
                />
                <div style={{ marginLeft: '5px' }}>
                  <CustomDocumentColumns
                    visibleColumns={visibleColumns || []}
                    setVisibleColumns={(dt) => this.setState({ visibleColumns: dt })}
                    customColumns={cfDeliveryChallanLine || []}
                    data={deliveryChallanLines}
                    updateData={(updatedData) => this.setState({ deliveryChallanLines: updatedData })}
                  />
                </div>
              </div>
            )}
            size="small"
            scroll={{ x: 'max-content' }}
            tableLayout="unset"
            top="none"
            bottom="bottomRight"
            // columns={selectedInvoice ? dcColumns.filter((item) => item?.title !== 'Transfer Quantity')
            //   : (selectedSt ? dcColumns.filter((item) => item?.title !== 'Invoice Quantity') : dcColumns.filter((item) => !['Invoice Quantity', 'Transfer Quantity'].includes(item?.title)))}
            columns={this.getColumns()}
            dataSource={deliveryChallanLines || []}
            pagination={false}
          />
          <div
            className="new-row-button"
            onClick={() => this.addNewRow()}
          >
            <span className="new-row-button__icon">
              <PlusCircleFilled />
            </span>
            <div>New Item</div>
          </div>
          <div className="ant-row" style={{ marginTop: '15px' }}>
            <div className="ant-col-md-24">
              <div className="ant-col-md-12">
                <div className="form__data-tc">
                  <label className="orgFormLabel">
                    Terms and Conditions
                  </label>

                  <RichTextEditor
                    onChange={(value) => this.setState({ t_and_c: value })}
                    disabled={createDCLoading || updateDCLoading || getDocConfigDeliveryChallanLoading}
                    value={t_and_c}
                  />

                </div>
              </div>
              <div className="ant-col-md-12" />
            </div>
          </div>
          <div className="custom-drawer__footer" style={{ display: 'flex', width: '100vw', paddingTop: '10px', gap: '10px' }}>
            <Fragment>
              <PRZButton
                id="save-as-draft"
                type="default"
                onClick={() => {
                  if (!createDCLoading || !updateDCLoading) {
                    this.addDC(false);
                  }
                }}
                isLoading={(createDCLoading || updateDCLoading) && buttonClick !== 'APPROVE'}
                disabled={createDCLoading || updateDCLoading || !deliveryChallan}
                wrapperStyle={{ marginRight: "10px" }}
                buttonStyle={{
                  width: "130px",
                  height: "40px",
                  border: "1px solid #2d7df7",
                  color: "#2d7df7",
                }}
              >
                Save as Draft
              </PRZButton>
              <PRZButton
                id="save-and-issue"
                type="default"
                onClick={() => {
                  if (!createDCLoading || !updateDCLoading) {
                    this.addDC(true);
                  }
                }}
                isLoading={(createDCLoading || updateDCLoading) && buttonClick === 'APPROVE'}
                disabled={createDCLoading || updateDCLoading || !deliveryChallan}
                wrapperStyle={{ marginRight: "10px" }}
                buttonStyle={{
                  width: "130px",
                  height: "40px",
                  border: "1px solid #2d7df7",
                  background: "rgb(45, 125, 247)",
                  color: "white",
                }}
              >
                Save and Issue
              </PRZButton>
            </Fragment>
            {!deliveryChallan && (
              <Popconfirm
                placement="topRight"
                title="This feature is not accessible within your current plan to use this feature contact us."
                onConfirm={() => window.Intercom('showNewMessage')}
                okText="Contact Us"
                cancelText="Cancel"
              >
                <img
                  className="barcode-restrict"
                  src={Crown}
                  alt="premium"
                  style={{
                    marginLeft: '8px',
                    marginTop: '5px',
                  }}
                />
              </Popconfirm>
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({
  UserReducers, DCReducers, CFV2Reducers, CurrenciesReducers, DocConfigReducers, CustomStatusReducers,
}) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  MONEY: UserReducers.MONEY,
  createDCLoading: DCReducers.createDCLoading,
  updateDCLoading: DCReducers.updateDCLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  cfV2DocDeliveryChallan: CFV2Reducers.cfV2DocDeliveryChallan,
  CurrenciesResults: CurrenciesReducers.CurrenciesResults,
  getCurrenciesLoading: CurrenciesReducers.getCurrenciesLoading,
  docConfigDeliveryChallan: DocConfigReducers.docConfigDeliveryChallan,
  getDocConfigDeliveryChallanLoading: DocConfigReducers.getDocConfigDeliveryChallanLoading,
  priceMasking: UserReducers.priceMasking,
  customStatusDeliveryChallan: CustomStatusReducers.customStatusDeliveryChallan,
});

const mapDispatchToProps = (dispatch) => ({
  getDCById: (tenantId, dcId) => dispatch(DCActions.getDCById(tenantId, dcId)),
  getDCByIdSuccess: (selectedDC) => dispatch(DCActions.getDCByIdSuccess(selectedDC)),
  createDC: (payload, callback) => dispatch(DCActions.createDC(payload, callback)),
  updateDC: (payload, callback) => dispatch(DCActions.updateDC(payload, callback)),
  deleteDC: (payload, callback) => dispatch(DCActions.deleteDC(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (customFields) => dispatch(CFV2Actions.getDocCFV2Success(customFields)),
  getProductById: (tenantId, productSkuId, tenantDepartmentId, callback) => dispatch(ProductActions.getProductById(tenantId, productSkuId, tenantDepartmentId, callback)),
  getCurrencies: (orgId) => dispatch(CurrenciesActions.getCurrencies(orgId)),
  getDocConfig: (tenantId, entityName, callback) => dispatch(DocConfigActions.getDocConfig(tenantId, entityName, callback)),
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DeliveryChallanForm));
